// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3LnQo","image":"Header_image__1F0iU","name":"Header_name__3l4sn","info":"Header_info__Yfve3","infoRow":"Header_infoRow__2-RYx"};